import React, { Fragment, useEffect } from 'react';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import { useParams } from 'react-router-dom';
import ClientActions from '../../../store/clientRedux';

import HrbTranslate from '../../../components/language/HrbTranslate';
import DateTime from '../../../components/library/common/DateTime';
import VerticalNameChildren from '../../../components/library/layout/VerticalNameChildren';
import EmdashText from '../../../components/library/common/EmdashText';

const ClientAccountHistory = () => {
    const dispatch = useDispatch();

    const { id } = useParams();

    const loading = useSelector(state => state.client.loadingAccountHistory);
    const accountHistory = useSelector(state => state.client.clientAccountHistory, shallowEqual)

    useEffect(() => {
        if (id) {
            dispatch(ClientActions.getAccountHistory(id));
        }
    }, [id]);

    return (
        <Fragment>
            <div className='columns'>
                <div className='column is-1' />
                <div className='column is-10'>
                    <h4 className='h4-vert-spacing'><HrbTranslate text='Account.Headers.AccountHistory' /></h4>
                </div>
                <div className='column is-1' />
            </div>
            <div className='columns'>
                <div className='column is-1' />
                <div className='column is-4'>
                    <VerticalNameChildren
                        textKey='Account.History.LastLogin'
                        loading={loading} >
                        {accountHistory && accountHistory.lastLoginLocation &&
                            <p className='p1 medium-weight'><HrbTranslate text={`Account.History.${accountHistory.lastLoginLocation}`} /></p>
                        }
                        {!loading && (!accountHistory || !accountHistory.lastLoginLocation) &&
                            <p className='p1 medium-weight'><EmdashText /></p>
                        }
                        {accountHistory && accountHistory.lastLogin &&
                            <p className='p1 medium-weight'><DateTime value={accountHistory.lastLogin} dateAndTime /></p>
                        }
                        {!loading && (!accountHistory || !accountHistory.lastLogin) &&
                            <p className='p1 medium-weight'><EmdashText /></p>
                        }
                    </VerticalNameChildren>
                </div>
                <div className='column is-4'>
                    <VerticalNameChildren
                        textKey='Account.History.LastModified'
                        loading={loading} >
                        {accountHistory && accountHistory.lastModifiedLocation &&
                            <p className='p1 medium-weight'>
                                <HrbTranslate text={`Account.History.${accountHistory.lastModifiedLocation}`} />
                            </p>
                        }
                        {accountHistory && accountHistory.lastModified &&
                            <p className='p1 medium-weight'><DateTime value={accountHistory.lastModified} dateAndTime/></p>
                        }
                        {!loading && (!accountHistory || !accountHistory.lastModified) &&
                            <p className='p1 medium-weight'><EmdashText /></p>
                        }
                    </VerticalNameChildren>
                </div>
                <div className='column is-2' />
                <div className='column is-1' />
            </div>
        </Fragment>
    );
}

ClientAccountHistory.whyDidYouRender = false;

export default ClientAccountHistory